import { Role, RoleContext } from '../../../pages/admin/icontact/setting/expert/agent/agent.const';

export enum AgentModalType {
  AGENT_TO_TRANSPORT,
  AGENT_IN_QUEUE,
  AGENT_IN_ROOM,
  AGENT_ONLINE,
  AGENT_READY_TO_CALL,
  // Add more modal types as needed
}
export enum AgentModalSearch {
  NAME = 'name',
  EMAIL = 'email',
  PHONE = 'phone',
  GROUP_ID = 'group_id',
  IN_QUEUE = 'in_queue',
}
export const getWidthSearch = length => {
  switch (length) {
    case 1:
      return '12';
    case 2:
      return '6';
    case 3:
      return '4';
    default:
      return '3';
  }
};

export class AgentModelConst {
  static displayColumns = type => {
    switch (type) {
      case AgentModalType.AGENT_TO_TRANSPORT:
      case AgentModalType.AGENT_READY_TO_CALL:
        return [
          {
            title: 'Tên người dùng',
            key: 'name',
            display: true,
            allowSort: false,
            classes: '',
          },
          {
            title: 'Email',
            key: 'email',
            display: true,
            allowSort: false,
            classes: '',
          },
          {
            title: 'Chức vụ',
            key: 'display_role',
            display: true,
            allowSort: false,
            classes: '',
          },
        ];
      case AgentModalType.AGENT_IN_QUEUE:
        return [
          {
            title: 'Tên người dùng',
            key: 'name',
            display: true,
            allowSort: false,
            classes: '',
          },
          {
            title: 'Email',
            key: 'email',
            display: true,
            allowSort: false,
            classes: '',
          },
          {
            title: 'Chức vụ',
            key: 'display_role',
            display: true,
            allowSort: false,
            classes: '',
          },
          {
            title: 'Độ ưu tiên',
            key: 'display_priority',
            display: true,
            allowSort: false,
            classes: 'text-center',
          },
        ];
    }
  };
  static getFilterSearch = type => {
    const data = [AgentModalSearch.NAME, AgentModalSearch.EMAIL, AgentModalSearch.GROUP_ID];
    switch (type) {
      case AgentModalType.AGENT_IN_QUEUE:
        data.push(AgentModalSearch.IN_QUEUE);
        break;
    }
    return data;
  };
  static getAgentModalAction = type => {
    switch (type) {
      case AgentModalType.AGENT_TO_TRANSPORT:
      case AgentModalType.AGENT_READY_TO_CALL:
        return [
          {
            action: AgentModalType.AGENT_TO_TRANSPORT,
            title: 'Chuyển cho chuyên viên',
            classes: 'btn-primary',
            content: `<i class="icon fa fa-share"></i> Chuyển`,
            display: true,
          },
        ];
      case AgentModalType.AGENT_IN_QUEUE:
        return [
          {
            action: 'add',
            title: 'Thêm vào hàng đợi',
            classes: 'btn-success',
            content: `<i class="icon fa fa-user-plus"></i> Thêm`,
            display: false,
          },
          {
            action: 'edit',
            title: 'Chỉnh sửa',
            classes: 'btn-primary',
            content: `<i class="icon fa fa-edit"></i> Sửa`,
            display: true,
          },
          {
            action: 'delete',
            title: 'Xóa khỏi hàng đợi',
            classes: 'btn-danger',
            content: `<i class="icon fa fa-close"></i> Xóa`,
            display: true,
          },
        ];
    }
  };
  static userRoleArray = () => {
    return [
      { id: Role.Agent, text: RoleContext.Agent },
      { id: Role.Supervisor, text: RoleContext.Supervisor },
      { id: Role.Administrator, text: RoleContext.Administrator },
      { id: Role.TeamLeader, text: RoleContext.TeamLeader },
    ];
  };
  static displayRoleColumns = (user, user_id) => {
    if (user._id === user_id) {
      return `<small class="badge badge-default">Là bạn</small>`;
    }
    switch (user.role) {
      case Role.Agent:
        return `<small class="badge badge-primary">` + RoleContext.Agent + `</small>`;
      case Role.Supervisor:
        return `<small class="badge badge-info">` + RoleContext.Supervisor + `</small>`;
      case Role.Administrator:
        return `<small class="badge badge-warning">` + RoleContext.Administrator + `</small>`;
      case Role.TeamLeader:
        return `<small class="badge badge-success">` + RoleContext.TeamLeader + `</small>`;
    }
  };
  static displayPriorityColumns = data => {
    switch (data.priority) {
      case 1:
        return `<small class="badge badge-primary">Chính</small>`;
      case 2:
        return `<small class="badge badge-info">Phụ</small>`;
      default:
        return '';
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/components/modals/agent-modal/agent-modal.const.ts